"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageApi = exports.StorageApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * StorageApi - axios parameter creator
 * @export
 */
const StorageApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} fileName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadStorageFile: async (fileName, options = {}) => {
            // verify required parameter 'fileName' is not null or undefined
            (0, common_1.assertParamExists)('downloadStorageFile', 'fileName', fileName);
            const localVarPath = `/api/storage/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.StorageApiAxiosParamCreator = StorageApiAxiosParamCreator;
/**
 * StorageApi -
 */
var StorageApi;
(function (StorageApi) {
    /**
     *
     * @param {string} fileName
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof StorageApi
     * url /api/storage/{fileName}
     */
    async function downloadStorageFile(fileName, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.StorageApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.downloadStorageFile(fileName, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            return res;
        });
    }
    StorageApi.downloadStorageFile = downloadStorageFile;
})(StorageApi || (exports.StorageApi = StorageApi = {}));
